import { ActivityContextQuestionAnswer } from '..';
import { LatestSubmissionPayload, QuestionPayload } from '../../../hydra';

export default function isSubmissionDifferent(
  submission: {
    feedback: string;
    currentSubmissionStatus: string;
    difficultyRating: number | null;
    questionSlugToAnswer: Record<string, ActivityContextQuestionAnswer>;
  },
  latestSavedSubmission: LatestSubmissionPayload,
  questions: Array<QuestionPayload>
) {
  const answerStates = latestSavedSubmission?.answer_states;
  if (!answerStates) {
    return true;
  }
  return (
    submission.difficultyRating !== latestSavedSubmission?.difficulty_rating ||
    submission.feedback !== latestSavedSubmission?.feedback ||
    !!questions.find((question) => {
      const answerState = answerStates[question.slug];
      const answerContext = submission.questionSlugToAnswer[question.slug];
      if (!answerState || !answerContext) {
        return true;
      }
      const answerIsDifferent =
        answerState.value !== answerContext.value;

      const codeIsDifferent =
        answerState.working_code !==
        { working_code: undefined, ...answerContext }.working_code;

      const correctnessIsDifferent =
        answerState.is_correct !== answerContext.isCorrect;

      return (
        answerIsDifferent ||
        codeIsDifferent ||
        correctnessIsDifferent
      );
    })
  );
}
